import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';
import { candExamsDPRoot } from '@cm/feature/exam';

const dpRoot = `${candExamsDPRoot}|Invalidate Candidate Exam`;

export type SPInvalidateCandidateExamLoc = 'SPInvalidateCandidateCheckboxLabel';

export const spInvalidateCandidateExamLocs: LocDefs<SPInvalidateCandidateExamLoc> = {
	SPInvalidateCandidateCheckboxLabel: {
		defaultValue: 'Notify candidate on invalidate',
		description: 'Label for the option to send candidate an automated email.',
		displayPath: `${dpRoot}|Send Email`,
		displayType: 'Label',
		feature: HubFeature.Exam,
		portal: 'SP',
	},
};

export const LOC_KEYS = MapLocKeys<SPInvalidateCandidateExamLoc>(spInvalidateCandidateExamLocs);
export type SpInvalidateExamLocType = LocMap<SPInvalidateCandidateExamLoc>;
